var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('em',[_vm._t("default",function(){return [_vm._v("Are your observations accurate and well-recorded? Could they be repeated by someone else?")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }